import { createSelector } from 'reselect';
import { atbCarouselsHomepageSelector } from 'selectors/testTarget/offers/atbCarouselsHomepage/atbCarouselsHomepageSelector';

const showSelector = createSelector(atbCarouselsHomepageSelector, atbCarouselsHomepage => !!atbCarouselsHomepage.show);

export { showSelector };
